import { mapState } from "vuex";

export default {
  name: "CompareModal",
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      sessionReservation: "currentReservation",
      sessionCurrentGuest: "currentGuest"
    })
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    proceed() {
      this.$emit("proceed", {
        reservation: this.sessionReservation,
        guest: this.sessionCurrentGuest
      });
    }
  }
};
